import { render } from "./AcceptAccount.vue?vue&type=template&id=0c68643e"
import script from "./AcceptAccount.vue?vue&type=script&lang=js"
export * from "./AcceptAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__